<template>
  <input-array :label="label"
               :value="parsed_value"
               :input-props="input_props"
               @input="ev => $emit(`input`, Object.assign({},ev))" />
</template>

<script>
import InputArray from 'VueComponents/InputArray';

export default {
  components: {
    InputArray,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: `Duration:`,
    },
    value: {
      type: [Object, Number],
      required: true,
    },
    days: {
      type: Boolean,
      required: false,
      default: true,
    },
    hours: {
      type: Boolean,
      required: false,
      default: true,
    },
    minutes: {
      type: Boolean,
      required: false,
      default: true,
    },
    seconds: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    numeric_value() {
      if (typeof this.value !== `number`) return this.durationObjToUnit(this.value);
      else return this.value;
    },
    parsed_value() {
      const val = moment.duration(this.numeric_value * 1000);

      return Object.entries({
        days: val.days(),
        hours: val.hours(),
        minutes: val.minutes(),
        seconds: val.seconds(),
      }).reduce((acc, [k, v]) => {
        acc[k] = isNaN(v) ? 0 : v;
        return acc;
      }, {});
    },
    input_props() {
      return [
        {
          label: `Days`,
          id: `days`,
          type: `number`,
          min: 0,
        },
        {
          label: `Hours`,
          id: `hours`,
          type: `number`,
          min: 0,
          max: 23,
        },
        {
          label: `Minutes`,
          id: `minutes`,
          type: `number`,
          min: 0,
          max: 59,
        },
        {
          label: `Seconds`,
          id: `seconds`,
          type: `number`,
          min: 0,
          max: 59,
        },
      ].reduce((acc, v) => {
        if (this[v.id] === true) acc.push(v);
        return acc;
      }, []);
    },
  },
};
</script>
